import React from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import Button from "@mui/material/Button";
import styles from "./AreYouSurePopup.module.css";
import { CircularProgress } from "@mui/material";
function AreYouSurePopup(props) {
  return (
    <DialogPopup
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          props.onClick();
        }
      }}
      title={props.title ? props.title : ""}
      open={props.open}
      onClose={() => props.close()}
      data-testid="are-you-sure-popup"
    >
      <div className={styles.content_container}>{props.children}</div>
      <div className="action_container">
        {props.isLoading ? (
          <div className={styles.loading}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <Button
              data-testid="are-you-sure-popup-cancel-btn"
              className="btn_cancel"
              onClick={() => props.close()}
            >
              {props.cancelBtn ? props.cancelBtn : "No"}
            </Button>
            <Button
              data-testid="are-you-sure-popup-confirm-btn"
              className={`btn_confirm ${
                props.confirmDisabled ? "btn_disabled" : ""
              }`}
              disabled={props.confirmDisabled ? props.confirmDisabled : false}
              onClick={props.onClick}
            >
              {props.confirmBtn ? props.confirmBtn : "Yes"}
            </Button>
          </>
        )}
      </div>
    </DialogPopup>
  );
}

export default AreYouSurePopup;
